import Image from 'next/image';

import Paragraph from '@/components/renderers/Paragraph';
import Heading from '@/components/renderers/Heading';
import CardLink from '@/components/CardLink';
import CardCTA from '@/components/CardCTA';

export default function DefaultCard({
  coverImage,
  externalUrl,
  linkPath,
  id,
  subTitle,
  title,
}) {
  return (
    <article className="flex flex-1" key={id}>
      <CardLink externalUrl={externalUrl} linkPath={linkPath}>
        {coverImage && (
          <div className="mb-2">
            <Image
              className="rounded-lg"
              src={coverImage.url}
              width={coverImage.width}
              height={coverImage.height}
              alt={coverImage?.alt}
            />
          </div>
        )}

        <div className="-mt-6">
          <Heading level={4} className="mb-2">
            {title}
          </Heading>
        </div>

        <Paragraph className="flex-grow">{subTitle}</Paragraph>

        <div className="flex items-center">
          <CardCTA label="Learn More" />
        </div>
      </CardLink>
    </article>
  );
}
